import type { TimeIteratorSerialized } from '@playq/octopus-common';

import { getInitialIterator } from '/shared/AppEntityCalendar/helpers/timeHelpers';

interface ICalendarState {
  experimentsTimeIterator: TimeIteratorSerialized;
  gameEventsTimeIterator: TimeIteratorSerialized;
  pending: boolean;
}

export const initialCalandarState: ICalendarState = {
  experimentsTimeIterator: getInitialIterator().serialize(),
  gameEventsTimeIterator: getInitialIterator().serialize(),
  pending: false,
};

export const CalendarTimeIteratorKeys = {
  ExperimentsTimeIterator: 'experimentsTimeIterator',
  GameEventsTimeIterator: 'gameEventsTimeIterator',
} as const;

export type CalendarTimeIteratorKeys = (typeof CalendarTimeIteratorKeys)[keyof typeof CalendarTimeIteratorKeys];

export interface ICalendarSetTimeIteratorPayload {
  key: CalendarTimeIteratorKeys;
  timeIterator: TimeIteratorSerialized;
}
